/**
 * 利润推演分析组件（重构版）
 */
import React, { useState, useEffect } from 'react';
import { Table, Card, Typography, Space } from 'antd';
import { CalculatorOutlined } from '@ant-design/icons';
import { ScenarioData } from './ProfitScenario/types';
import { createColumns } from './ProfitScenario/columns';
import { generateDefaultScenarios, calculateScenarioData } from './ProfitScenario/scenarioData';

const { Text } = Typography;

interface ProfitScenarioAnalysisProps {
    price: number; // 目标售价
    profitMarginPreAd: number; //广告前利润率 (毛利率)
    landedCost: number; // 到岸成本 (用于计算投资回报)
}

export const ProfitScenarioAnalysis: React.FC<ProfitScenarioAnalysisProps> = ({
    price: priceInput,
    profitMarginPreAd: profitMarginInput,
    landedCost: landedCostInput
}) => {
    // 确保所有输入都是有效数字
    const price = Number(priceInput) || 0;
    const profitMarginPreAd = Number(profitMarginInput) || 0;
    const landedCost = Number(landedCostInput) || 0;

    // 默认场景数据
    const [data, setData] = useState<ScenarioData[]>(generateDefaultScenarios());

    // 自动计算逻辑
    useEffect(() => {
        setData(prev => calculateScenarioData(prev, price, profitMarginPreAd));
    }, [price, profitMarginPreAd, data]); // 依赖 data 中的各字段变化

    const handleChange = (key: string, field: keyof ScenarioData, value: any) => {
        setData(prev => prev.map(item => {
            if (item.key === key) {
                return { ...item, [field]: value };
            }
            return item;
        }));
    };

    const columns = createColumns(price, profitMarginPreAd, landedCost, handleChange);

    return (
        <Card
            size="small"
            title={<Space><CalculatorOutlined /> 广告策略与利润推演模型</Space>}
            style={{ background: '#f9f9f9' }}
            bodyStyle={{ padding: 0 }}
        >
            <div style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0' }}>
                <Space size="large">
                    <Text type="secondary" style={{ fontSize: 14 }}>当前目标售价: <Text strong style={{ fontSize: 14 }}>${price.toFixed(2)}</Text></Text>
                    <Text type="secondary" style={{ fontSize: 14 }}>广告前毛利率: <Text strong style={{ fontSize: 14 }}>{profitMarginPreAd.toFixed(2)}%</Text></Text>
                    <Text type="secondary" style={{ fontSize: 14 }}>完税成本: <Text strong style={{ fontSize: 14 }}>${landedCost.toFixed(2)}</Text></Text>
                </Space>
            </div>
            <Table
                columns={columns}
                dataSource={data}
                pagination={false}
                size="middle"
                scroll={{ x: 1300 }}
                bordered
            />
        </Card>
    );
};
